import React from 'react';
import styled from 'styled-components';
import typesTypes from './prop-types';
import { Num } from './styles';

const Container = styled.div`
  align-items: flex-end;
  min-width: 40px;
  margin-right: 16px;
  margin-left: -56px;

  & > .header {
    color: ${props => props.theme.bodyColor};
  }

  &&& > .cell {
    ${Num};
    min-width: 7.8px;
  }
`;

export default function Total({ types }) {
  return (
    <Container>
      <span className="header">total</span>
      {types.map(({ type, pct }) => (
        <span key={type} className="cell">
          {`${pct}%`}
        </span>
      ))}
    </Container>
  );
}

Total.propTypes = { types: typesTypes.isRequired };
